<tgt-modal [witdhModal]="'50%'" [openOrClose]="false">
  <main>

    <div class="header">
      <img src="assets/images/cadastrado.png" alt="">
      <div class="infos">
        <span>Bem vindo ao <strong>Escolar AI</strong>!</span>
        <p>Cadastre a sua primeira Escola e aproveite todos os recursos que nossa plataforma oferece!</p>
        <tgt-button [size]="'small'" (click)="cadastrarEscola()">Cadastrar Escola</tgt-button>
      </div>
    </div>

  </main>
</tgt-modal>
